// extracted by css-extract-rspack-plugin
export default {"SanitizedHtml":"sanitized-group-header-text-module__SanitizedHtml__JqvOZf6"};